import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Реестр пользователей", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "v-data-table__tr" }
const _hoisted_5 = ["colspan"]

import { computed, ref, Ref } from 'vue'
import {
  AppAuthService,
  Id,
  MunicipalEntitiesService,
  MunicipalEntity,
  Role,
  RolesService,
  User,
  UsersService,
  userGetFullname,
  Permissions,
  UserOrderFields,
  OrderDirection,
  RoleType,
} from '@prodcard/core'
import { Pagination } from '../../../../components'
import FilterBox from './FilterBox.vue'
import { usePaginator, Paginator, useAuthPermissions } from '../../../../mixins'
import { SearchParams } from '../interfaces'
import { createCtx, handleError, useWatcherSavedRef } from '../../../../helpers'
import { uniq } from 'lodash'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersListPage',
  props: {
    userService: {},
    municipalEntitiesService: {},
    rolesService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;


const router = useRouter()

const { paginator, count, getPageCount, resetPage } = usePaginator('userListPaginator')
const { currentMunicipalEntityId, hasPermissions, currentUserRole } = useAuthPermissions(props.authService)
const users: Ref<User[]> = ref([])
const roles: Ref<Role[]> = ref([])

const municipalEntities: Ref<MunicipalEntity[]> = ref([])
const loading = ref(false)

const hasView = computed(() => {
  return hasPermissions(Permissions.USERS_VIEW)
})
const hasMeView = computed(() => {
  return hasPermissions(Permissions.ME_USERS_VIEW)
})
const hasManage = computed(() => {
  return hasPermissions(Permissions.USERS_MANAGE) || hasPermissions(Permissions.ME_USERS_MANAGE)
})

const headers = [
  { title: 'ФИО', key: 'fullname', sortable: false },
  { title: 'Email', key: 'email', sortable: false },
  { title: 'MO', key: 'municipalEntity', sortable: false },
  { title: 'Роль', key: 'role', sortable: false },
]

const searchParams: Ref<SearchParams> = useWatcherSavedRef('userListParams', {
  search: '',
  municipalEntityId: !hasView.value && hasMeView.value ? currentMunicipalEntityId.value : undefined,
  roleId: undefined,
})

const updateSearchParams = (newSearchParams: SearchParams) => {
  searchParams.value = newSearchParams
  resetPage()
  update(paginator.value, searchParams.value)
}

const update = (paginator: Paginator, filter: SearchParams) =>
  handleError(async () => {
    const ctx = createCtx()
    const from = (paginator.page - 1) * paginator.per
    const userResponse = await props.userService.findAll(ctx, {
      paging: { from: from, count: paginator.per },
      filter,
      order: { field: UserOrderFields.CREATED_AT, direction: OrderDirection.DESC },
    })

    if (!roles.value.length) {
      const roleList = await props.rolesService.findAll(ctx)
      roles.value = roleList.filter(r => {
        if (currentUserRole.value?.type === RoleType.MODERATOR) return r.type !== RoleType.ADMIN
        return true
      })
    }

    const idsME = uniq(userResponse.items.map(u => u.municipalEntityId))

    const { items } = await props.municipalEntitiesService.findAll(ctx, {
      filter: { ids: idsME.filter((id): id is Id => !!id) },
    })

    municipalEntities.value = items

    users.value = userResponse.items.map(u => ({ ...u, fullname: userGetFullname(u) }))
    count.value = userResponse.total
  }, loading)

const openDetails = async (e: Event, val: { item: { value: string } }) => {
  if (hasManage.value) {
    await router?.push('/users/' + val.item.value + '/edit')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!

  return (_openBlock(), _createBlock(_component_v_data_table_server, {
    headers: headers,
    items: users.value,
    loading: loading.value,
    "items-length": _unref(count),
    rounded: true,
    "no-data-text": "Нет данных",
    "hide-default-footer": "",
    hover: "",
    "onUpdate:options": _cache[2] || (_cache[2] = ($event: any) => (update(_unref(paginator), _unref(searchParams)))),
    "onClick:row": openDetails
  }, {
    top: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (hasManage.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              to: "/users/new",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Создать")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FilterBox, {
        class: "my-5",
        "role-list": roles.value,
        "municipal-entities-service": _ctx.municipalEntitiesService,
        "default-search-params": _unref(searchParams),
        loading: loading.value,
        readonlyMe: !hasView.value && hasMeView.value,
        onUpdate: updateSearchParams
      }, null, 8, ["role-list", "municipal-entities-service", "default-search-params", "loading", "readonlyMe"])
    ]),
    "item.municipalEntity": _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(municipalEntities.value.find(me => me.id === item.raw.municipalEntityId)?.name ?? item.raw.municipalEntityId), 1)
    ]),
    "item.role": _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(roles.value.find(role => role.id === item.raw.roleId)?.name ?? item.raw.roleId), 1)
    ]),
    tfoot: _withCtx(() => [
      (_unref(count) > 0)
        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_3, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("td", {
                colspan: headers.length,
                class: "v-data-table__td text-right"
              }, [
                _createTextVNode(" Итого: "),
                _createElementVNode("b", null, _toDisplayString(_unref(count)), 1)
              ], 8, _hoisted_5)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    bottom: _withCtx(() => [
      _createVNode(_unref(Pagination), {
        modelValue: _unref(paginator),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(paginator) ? (paginator).value = $event : null)),
          _cache[1] || (_cache[1] = ($event: any) => (update(_unref(paginator), _unref(searchParams))))
        ],
        "page-count": _unref(getPageCount),
        disabled: loading.value || _unref(getPageCount) === 0,
        class: "mt-5"
      }, null, 8, ["modelValue", "page-count", "disabled"])
    ]),
    _: 1
  }, 8, ["items", "loading", "items-length"]))
}
}

})